/* Education Cards GA4 storefront events. Keeps one guarded gtag destination. */
(() => {
  const config = document.querySelector('[data-ec-ga4]');
  const measurementId = config?.dataset.measurementId;
  if (!measurementId || window.__ecAnalyticsInitialized) return;
  window.__ecAnalyticsInitialized = true;

  window.dataLayer = window.dataLayer || [];
  window.gtag = window.gtag || function gtag() { window.dataLayer.push(arguments); };
  const hasConfig = window.dataLayer.some((entry) => Array.isArray(entry) && entry[0] === 'config' && entry[1] === measurementId);
  if (!hasConfig) {
    window.gtag('js', new Date());
    window.gtag('config', measurementId);
  }

  window.gtag('config', 'AW-18028973655');

  if (!document.querySelector(`script[src*="googletagmanager.com/gtag/js?id=${measurementId}"]`)) {
    const script = document.createElement('script');
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(measurementId)}`;
    document.head.appendChild(script);
  }

  const currency = 'UAH';
  const money = (cents) => Number((Number(cents || 0) / 100).toFixed(2));
  const cleanText = (value) => String(value || '').replace(/\s+/g, ' ').trim();
  const track = (name, params = {}) => window.gtag('event', name, params);
  window.EducationCardsAnalytics = { track, currency, money };

  const itemFromElement = (element, index) => {
    if (!element) return null;
    const price = Number(element.dataset.analyticsPrice || 0);
    const item = {
      item_id: String(element.dataset.analyticsVariantId || element.dataset.analyticsProductId || ''),
      item_name: cleanText(element.dataset.analyticsProductName),
      item_variant: cleanText(element.dataset.analyticsVariantName),
      price: Number.isFinite(price) ? price : 0,
    };
    if (Number.isFinite(index)) item.index = index;
    return item.item_id && item.item_name ? item : null;
  };

  const itemFromCartLine = (line, quantity) => ({
    item_id: String(line.variant_id || line.id || ''),
    item_name: cleanText(line.product_title || line.title),
    item_variant: cleanText(line.variant_title),
    price: money(line.final_price || line.price),
    quantity: Number(quantity || line.quantity || 1),
  });

  const listEvents = () => {
    document.querySelectorAll('[data-ec-analytics-list]').forEach((list) => {
      if (list.dataset.analyticsTracked === 'true') return;
      const items = [...list.querySelectorAll('[data-ec-analytics-product]')].map(itemFromElement).filter(Boolean);
      if (!items.length) return;
      list.dataset.analyticsTracked = 'true';
      track('view_item_list', {
        item_list_id: list.dataset.analyticsListId || '',
        item_list_name: list.dataset.analyticsListName || '',
        items,
      });
    });
  };

  const productView = () => {
    const product = document.querySelector('[data-ec-analytics-product-page]');
    const item = itemFromElement(product);
    if (item) track('view_item', { currency, value: item.price, items: [item] });
  };

  const cartView = async () => {
    if (window.location.pathname !== '/cart') return;
    try {
      const response = await fetch('/cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' });
      if (!response.ok) return;
      const cart = await response.json();
      track('view_cart', { currency, value: money(cart.total_price), items: (cart.items || []).map(itemFromCartLine) });
    } catch (_) {}
  };

  const bodyData = (body) => {
    if (!body) return {};
    if (typeof body === 'string') {
      try { return JSON.parse(body); } catch (_) { return Object.fromEntries(new URLSearchParams(body)); }
    }
    if (body instanceof URLSearchParams) return Object.fromEntries(body);
    if (body instanceof FormData) return Object.fromEntries(body);
    return {};
  };

  const originalFetch = window.fetch.bind(window);
  window.fetch = function analyticsFetch(input, init = {}) {
    const url = typeof input === 'string' ? input : input?.url || '';
    const isAdd = /\/cart\/add\.js(?:\?|$)/.test(url);
    const request = isAdd ? bodyData(init.body) : null;
    return originalFetch(input, init).then((response) => {
      if (!isAdd || !response.ok) return response;
      response.clone().json().then((result) => {
        const requested = request?.items || (request?.id ? [{ id: request.id, quantity: request.quantity || 1 }] : []);
        const lines = Array.isArray(result.items) ? result.items : [result];
        const items = lines.map((line) => {
          const requestedLine = requested.find((entry) => String(entry.id) === String(line.variant_id || line.id));
          return itemFromCartLine(line, requestedLine?.quantity);
        }).filter((item) => item.item_id && item.item_name);
        // if (items.length) track('add_to_cart', { currency, value: items.reduce((total, item) => total + item.price * item.quantity, 0), items });
        if (items.length) {
  const value = items.reduce((total, item) => total + item.price * item.quantity, 0);

  track('add_to_cart', {
    currency,
    value,
    items,
  });

  track('conversion_event_add_to_cart', {
    currency,
    value,
    items,
  });
}
      }).catch(() => {});
      return response;
    });
  };

  const checkoutIntent = () => {
    if (window.__ecCheckoutTracked || document.querySelector('[data-ec-cart-minimum].is-blocked')) return;
    window.__ecCheckoutTracked = true;
    originalFetch('/cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then((response) => response.ok ? response.json() : null)
      .then((cart) => {
        if (cart) track('begin_checkout', { currency, value: money(cart.total_price), items: (cart.items || []).map(itemFromCartLine) });
      })
      .catch(() => {});
  };

  document.addEventListener('click', (event) => {
    const productLink = event.target.closest('[data-ec-analytics-product] a[href]');
    if (productLink) {
      const card = productLink.closest('[data-ec-analytics-product]');
      const list = card?.closest('[data-ec-analytics-list]');
      const item = itemFromElement(card);
      if (list && item) track('select_item', { item_list_id: list.dataset.analyticsListId || '', item_list_name: list.dataset.analyticsListName || '', items: [item] });
    }
    const link = event.target.closest('a[href]');
    if (link) {
      const url = new URL(link.href, window.location.origin);
      const destinations = {
        '/pages/wholesale-builder': 'wholesale_builder',
        '/collections/cup-figures': 'cup_figures',
        '/collections/keychains': 'keychains',
        '/pages/wholesale': 'wholesale',
        '/pages/cafes': 'cafes',
        '/pages/kids': 'kids',
        '/pages/information': 'information',
      };
      if (destinations[url.pathname]) track('destination_click', { destination: destinations[url.pathname], link_url: url.pathname, link_text: cleanText(link.textContent), source_path: window.location.pathname });
      if (/^https?:\/\/(www\.)?instagram\.com$/i.test(`${url.protocol}//${url.hostname}`)) track('destination_click', { destination: 'instagram', link_url: url.href, link_text: cleanText(link.textContent), source_path: window.location.pathname });
    }
  }, true);

  window.addEventListener('education-cards:wishlist', (event) => {
    const item = itemFromElement(event.detail?.button?.closest?.('[data-ec-analytics-product]'));
    if (!item) return;
    track(event.detail.action === 'add' ? 'add_to_wishlist' : 'remove_from_wishlist', { currency, value: item.price, items: [item] });
  });

  document.addEventListener('submit', (event) => {
    const form = event.target.closest('form[role="search"], form[action*="/search"]');
    if (!form) return;
    const input = form.querySelector('[name="q"]');
    const searchTerm = cleanText(input?.value).replace(/\s+NOT\s+tag:ec-keychains-wholesale/ig, '');
    if (searchTerm) track('search', { search_term: searchTerm });
  }, true);

  window.addEventListener('click', (event) => {
    const checkout = event.target.closest('[data-ec-minimum-checkout], [name="checkout"]');
    if (checkout && !checkout.disabled && checkout.getAttribute('aria-disabled') !== 'true') checkoutIntent();
  }, true);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => { productView(); listEvents(); cartView(); }, { once: true });
  else { productView(); listEvents(); cartView(); }
})();
